import { IUndergroundInfoSchema } from '../../../../../repositories/monolith-python/entities/offer/UndergroundInfoSchema';
import { TOfferUndergrounds } from '../../../../reducers';

export const mapUndergrounds = (undergrounds: TOfferUndergrounds | null): Array<IUndergroundInfoSchema> | null => {
  if (!Array.isArray(undergrounds)) {
    return null;
  }

  // Отфильтровываем незаполненные станции
  return undergrounds.filter(({ id }) => !!id);
};
